/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, July 2022
 * @flow
 */

import React from 'react';
import PropTypes from 'prop-types';
import extraButton from '../../../../assets/images/Fireboard/action_black.png';
import classes from './ShapeInfoPopup.module.css';
import clearTableImg from '../../../../assets/images/TMS/clearTable.png';
import mergeIcon from '../../../../assets/images/TMS/merge.png';
import unmergeIcon from '../../../../assets/images/TMS/split.png';
import moveTableIcon from '../../../../assets/images/TMS/moveTable.png';
import infoIcon from '../../../../assets/images/Fireboard/infoIcon.png';
import smsIcon from '../../../../assets/images/TMS/sms.png';
import actionBlackImg from '../../../../assets/images/Fireboard/action_black.png';
import voidCheckImg from '../../../../assets/images/TMS/voidCheck.png';
import Button from '../../../../components/Button';

const ShapeInfoPopup = ({
  selectedCheck,
  onClose,
  tmsView = false,
  unseatGuest,
  selectedShape,
  openMergeStationPopup,
  invokeTableUnmerge,
  onClickInfo,
  onClickSms,
  transferTable,
  openTableMenu,
  onVoidCheck,
}) => {
  const {
    number,
    stationName,
    ellapsedTime,
    paid,
    employeeFirstName,
    employeeLastName,
    onHandleCheckActions,
    isClearWaitlistEnabled = false,
    isMoveTableEnabled,
    isVoidCheckEnabled,
  } = selectedCheck || {};

  const { x, y, parentStationId, mergedStationIds } = selectedShape || {};
  const disableMerge = parentStationId;

  const unmergeCriteria = parentStationId || (mergedStationIds && mergedStationIds.length > 0);

  let employeeName = `${employeeFirstName ? employeeFirstName : ''} ${employeeLastName ? employeeLastName : ''}`;
  employeeName = employeeName.trim();

  const clearWaitList = () => {
    if (isClearWaitlistEnabled) {
      unseatGuest();
    }
  }

  const mergeTable = () => {
    if (!disableMerge) {
      openMergeStationPopup(selectedShape, selectedCheck);
    }
  }

  const unmergeTable = () => {
    if (unmergeCriteria) {
      invokeTableUnmerge();
    }
  }

  const invokeMoveTable = () => {
    transferTable && transferTable(selectedShape && selectedShape.stroke === "red");
  }

  return (
    <div
      style={{
        top: y + 40 + 'px',
        left: x + 20 + 'px',
      }}
      className={classes.container}
    >
      <div className={classes.wrapper}>
        <div className={classes.smallTriangle} />
        <div className={classes.row}>
          <div className={classes.leftSection}>
            <div className={classes.label600}>{stationName}</div>
            <div className={classes.label}>#{number}</div>
            <div className={classes.label}>{employeeName}</div>
            <div className={classes.label}>{ellapsedTime}</div>
          </div>
          <div className={classes.rightSection}>
            <div onClick={onClose} className={classes.closeIcon}>X</div>
          </div>
        </div>
        <div className={classes.row}>
          {tmsView && (
            <div className={classes.column}>
              <div className={classes.rowWise}>
                <IconButton src={infoIcon} alt={'info'} onClick={onClickInfo} />
                <IconButton src={smsIcon} alt={'sms'} onClick={onClickSms} />
              </div>
              <div className={classes.rowWise}>
                <IconButton src={mergeIcon} alt={'merge'} onClick={mergeTable} disabled={disableMerge} />
                <IconButton src={unmergeIcon} alt={'unmerge'} onClick={unmergeTable} disabled={!unmergeCriteria} />
                <IconButton src={moveTableIcon} alt={'move'} onClick={invokeMoveTable} disabled={!isMoveTableEnabled} />
                <IconButton src={clearTableImg} alt={'clear-waitlist'} onClick={clearWaitList} disabled={!isClearWaitlistEnabled} />
                <IconButton src={voidCheckImg} alt={'voidcheck'} onClick={onVoidCheck} disabled={!isVoidCheckEnabled} />
                <IconButton src={actionBlackImg} alt={'extra'} onClick={openTableMenu} style={{ marginRight: 0 }} />
              </div>
            </div>
          )}
          {!tmsView && (
            <div className={classes.rowWise}>
              <IconButton src={paid} alt={'payment status'} onClick={() => { }} />
              <IconButton src={extraButton} alt={'extra'} onClick={onHandleCheckActions} />
            </div>
          )}
        </div>
      </div>
    </div>
  )
};

export default ShapeInfoPopup;

ShapeInfoPopup.propTypes = {
  selectedShape: PropTypes.object,
  selectedCheck: PropTypes.object,
  onClose: PropTypes.func,
};

ShapeInfoPopup.defaultProps = {
  selectedShape: {},
  selectedCheck: {},
  onClose: () => { },
};

const IconButton = ({
  disabled,
  onClick,
  src,
  alt,
  style,
}) => {
  const dummyFunc = () => { };
  return (
    <Button style={style} disabled={disabled} onClick={onClick || dummyFunc} className={classes.iconBtn} >
      <img src={src} alt={alt || 'img'} className={classes.img} />
    </Button >
  );
};
